import { FlexBox, GridContainer, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { ContinueShopping } from '../shared/ContinueShopping';
import { useSiteData } from '../../hooks/useSiteData';
import { HistoryViewHeader } from './HistoryViewHeader';

export const EmptyHistory = () => {
  const [emptyOrderHistory = {}] = useTranslations(['emptyOrderHistory']);
  const { allowAnonymous } = useSiteData();

  return (
    <GridContainer>
      <HistoryViewHeader showSearchBar={allowAnonymous} />
      <FlexBox
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        pt={5}
      >
        <Typography fontSize="large" fontWeight="bold" mb={5}>
          {emptyOrderHistory.emptyHistoryReason}
        </Typography>
        <Typography mb={5}>{emptyOrderHistory.emptyHistory}</Typography>
        {allowAnonymous ? (
          <Typography mb={5}>{emptyOrderHistory.guestOrderSearch}</Typography>
        ) : null}
        <ContinueShopping />
      </FlexBox>
    </GridContainer>
  );
};
